const REVEAL_STATE = {
  pending: 'pending',
  visible: 'visible',
  complete: 'complete',
};

const observedSections = new WeakSet();
const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
const isDesignMode = document.documentElement.classList.contains('shopify-design-mode');

const isPrettyPortalSection = (element) => {
  if (!(element instanceof HTMLElement) || !element.classList.contains('section')) return false;

  return Array.from(element.classList).some((className) => className.startsWith('pp-'));
};

const sectionIsAlreadyInView = (section) => {
  const rect = section.getBoundingClientRect();
  return rect.top < window.innerHeight * 0.9 && rect.bottom > 0;
};

const markSectionVisible = (section) => {
  section.dataset.ppScrollReveal = REVEAL_STATE.visible;

  window.setTimeout(() => {
    if (section.dataset.ppScrollReveal === REVEAL_STATE.visible) {
      section.dataset.ppScrollReveal = REVEAL_STATE.complete;
    }
  }, 900);
};

const observer =
  'IntersectionObserver' in window && !prefersReducedMotion.matches && !isDesignMode
    ? new IntersectionObserver(
        (entries) => {
          for (const entry of entries) {
            if (!entry.isIntersecting && entry.intersectionRatio <= 0) continue;

            const section = entry.target;
            if (!(section instanceof HTMLElement)) continue;

            markSectionVisible(section);
            observer?.unobserve(section);
          }
        },
        {
          rootMargin: '0px 0px -12% 0px',
          threshold: [0, 0.16],
        }
      )
    : null;

const registerSection = (section) => {
  if (!isPrettyPortalSection(section) || observedSections.has(section)) return;

  observedSections.add(section);
  section.classList.add('pp-scroll-reveal');

  if (!observer || prefersReducedMotion.matches || isDesignMode || sectionIsAlreadyInView(section)) {
    markSectionVisible(section);
    return;
  }

  section.dataset.ppScrollReveal = REVEAL_STATE.pending;
  observer.observe(section);
};

const registerSections = (root = document) => {
  if (root instanceof HTMLElement && isPrettyPortalSection(root)) {
    registerSection(root);
  }

  const sections = root.querySelectorAll?.('.section');
  if (!sections) return;

  for (const section of sections) {
    registerSection(section);
  }
};

const initPrettyPortalScrollReveal = () => {
  registerSections();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initPrettyPortalScrollReveal, { once: true });
} else {
  initPrettyPortalScrollReveal();
}

document.addEventListener('shopify:section:load', (event) => {
  registerSections(event.target);
});
